import { render } from "./TmplDistLayer.vue?vue&type=template&id=8b0a607c&ts=true"
import script from "./TmplDistLayer.vue?vue&type=script&lang=ts"
export * from "./TmplDistLayer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__